const GLOBAL_TRACKING_KEYS = ['promoType']

export const pushToDatalayer = (dataLayerVariables: object) => {
  const globalTrackingData: { [key: string]: string } = {}

  GLOBAL_TRACKING_KEYS.forEach((itemKey: string) => {
    const storageValue = localStorage.getItem(itemKey)
    if (storageValue) globalTrackingData[itemKey] = storageValue
  })

  window?.dataLayer?.push({
    ...dataLayerVariables,
    ...globalTrackingData
  })
}
